module.exports = __webpack_public_path__ + "static/media/FT-COMPU-AI.f2c299bf.png";